import { Injectable, Inject } from '@angular/core';

import {GroupPolicyAgentDO} from'./groupPolicyAgent.model';
import {GroupPolicyClientDO} from'./groupPolicyClient.model';
import {GroupPolicyPaymentDO} from'./groupPolicyPayment.model';
import {GroupPolicyDetailDO} from'./groupPolicyDetail.model';

import {GroupPolicyPremiumBreakupDO} from'./groupPolicyPremiumBreakup.model';


export class GroupPolicyDO  {

   
    public  id:number = null;
    public contractNum:string;
    public clientId:number;
    public clientRefGuid:string;
    public productCd:string=null;
    public schemeCd:string=null;
    public productVersion:string=null;
    public sumInsured:number;
    public premium:number;
    public promoCode:string;
    public premiumStatusCd:string;
    public proposalEntryDt:Date=null;
	public proposalReceivedDt:Date=null;
	public commencementDt:Date=null;
	public expiryDt:Date=null;
    public issueDt:Date=null;
    public stageCd:string;
    public groupSize:number;
    public ownerType:string;
    public payerType:string; 
    public baseProductFamilyCd:string;

   public groupPolicyAgentList:GroupPolicyAgentDO[]=[];
    public groupPolicyClientList:GroupPolicyClientDO[]=[];
    public groupPolicyPaymentList:GroupPolicyPaymentDO[]=[];
    public groupPremiumBreakupList: GroupPolicyPremiumBreakupDO[]=[];
    public groupPolicyDtlList:GroupPolicyDetailDO[]=[];
    
}